import { ProjectActivityMaterialsDataGridBase } from "src/components/views/erp/project/projectActivity/material/ProjectActivityMaterialsDataGridBase.tsx";
import { ProjectActivityMaterialsDataGridApi } from "src/api/generated/erp/project/projectActivityMaterial/api/projectActivityMaterialsDataGridApi.ts";

export interface SubProjectAllActivityMaterialsDataGridProps {
	projectId: number;
	subProjectId: number;
}

export const SubProjectAllActivityMaterialsDataGrid = ({
	projectId,
	subProjectId,
}: SubProjectAllActivityMaterialsDataGridProps) => {
	return (
		<ProjectActivityMaterialsDataGridBase
			gridId={"E8B3C42A9F701D5E"}
			fetchData={({
				showCancelledLines,
				searchQuery,
				stateFilter,
				acquisitionMethodFilter,
				lineFilterMode,
				dataModelRequest,
			}) =>
				ProjectActivityMaterialsDataGridApi.getDataGridDataForProject({
					projectId: projectId,
					subProjectId: subProjectId,
					cancelledLines: showCancelledLines,
					searchQuery: searchQuery,
					stateFilter: stateFilter,
					acquisitionMethodFilter: acquisitionMethodFilter,
					lineFilterMode: lineFilterMode,
					dataModelRequest: dataModelRequest,
				})
			}
			showActivityColumn
			showSubProjectColumn={false}
			showSubProjectFilter={false}
		/>
	);
};
